import { Component, Input } from '@angular/core';
import { PortalRole } from '@edl-development/edl-common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edl-toggle-role-modal',
  templateUrl: './edl-toggle-role-modal.component.html',
  styleUrls: ['./edl-toggle-role-modal.component.scss']
})
export class EdlToggleRoleModalComponent {
  @Input() roles: [PortalRole];

  constructor(
      public activeModal: NgbActiveModal,
  ) {}

  ngOnInit() {

  }

  ok() {
      this.activeModal.close(this.roles);
  }

  cancel() {
      this.activeModal.dismiss();
  }

  selectalll(){
      this.roles.forEach(element => {
          element.IsSelected = true;
      });
  }

  deselectalll(){
      this.roles.forEach(element => {
          element.IsSelected = false;
      });
  }
}

